// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-updater-node {
  /* height: 50px; */
  border: 1px solid #eee;
  padding: 5px;
  border-radius: 5px;
  background: white;
}

.text-updater-node label {
  display: block;
  color: #777;
  font-size: 12px;
}
.nodecontainer {
  height: 99vh;
  overflow: auto;
}

#home {
  height: 90vh;
}
.nodeOptions {
  margin-top: 3%;
  display: flex;
  gap: 2%;
  align-items: center;
}
.btn-primary {
  background-color: rgb(3, 10, 29) !important;
  color: white !important;
  border: 1px solid grey;
}
.title {
  color: rgb(231, 231, 231);
  font-size: 0.9rem;
  font-weight: 500;
  /* font-weight: lighter; //daa520*/
}

/* .btn-primary:hover {
  color: black !important;
} */
.dropdown-toggle::after {
  display: none !important;
}

.Section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}

.NotebookRadiobutton {
  /* margin-top: 10px; */
  display: flex;
}

.savebutton {
  background-color: #8b5ccc;
  border: none;
  color: white;
  padding: 5px 27px;
  border-radius: 5px;
}

.modulescluster {
  text-align: center;
  /* width: 15%; */
  border-radius: 5px;
  padding: 10px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
}

.code {
  display: flex;
  align-items: center;
  gap: 24.5%;
  padding-top: 1%;
  /* justify-content: center; */
}

#ex1 {
  /* border: 1px solid whitesmoke; */
  /* padding: 2px; */
  border-radius: 5px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  background-color: #8b5ccc;
}
.nav-link,
.nav-link:hover {
  color: black;
}

/* .react-flow__node-input, */
.react-flow__node {
  height: 28px !important;
  width: 28px !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/etlModule/etl.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;AACjB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,aAAa;EACb,OAAO;EACP,mBAAmB;AACrB;AACA;EACE,2CAA2C;EAC3C,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;;GAEG;AACH;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,uBAAuB;EACvB,sBAAsB;AACxB","sourcesContent":[".text-updater-node {\n  /* height: 50px; */\n  border: 1px solid #eee;\n  padding: 5px;\n  border-radius: 5px;\n  background: white;\n}\n\n.text-updater-node label {\n  display: block;\n  color: #777;\n  font-size: 12px;\n}\n.nodecontainer {\n  height: 99vh;\n  overflow: auto;\n}\n\n#home {\n  height: 90vh;\n}\n.nodeOptions {\n  margin-top: 3%;\n  display: flex;\n  gap: 2%;\n  align-items: center;\n}\n.btn-primary {\n  background-color: rgb(3, 10, 29) !important;\n  color: white !important;\n  border: 1px solid grey;\n}\n.title {\n  color: rgb(231, 231, 231);\n  font-size: 0.9rem;\n  font-weight: 500;\n  /* font-weight: lighter; //daa520*/\n}\n\n/* .btn-primary:hover {\n  color: black !important;\n} */\n.dropdown-toggle::after {\n  display: none !important;\n}\n\n.Section {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 10px;\n}\n\n.NotebookRadiobutton {\n  /* margin-top: 10px; */\n  display: flex;\n}\n\n.savebutton {\n  background-color: #8b5ccc;\n  border: none;\n  color: white;\n  padding: 5px 27px;\n  border-radius: 5px;\n}\n\n.modulescluster {\n  text-align: center;\n  /* width: 15%; */\n  border-radius: 5px;\n  padding: 10px;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n  transition: 0.3s;\n}\n\n.code {\n  display: flex;\n  align-items: center;\n  gap: 24.5%;\n  padding-top: 1%;\n  /* justify-content: center; */\n}\n\n#ex1 {\n  /* border: 1px solid whitesmoke; */\n  /* padding: 2px; */\n  border-radius: 5px;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n}\n\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  background-color: #8b5ccc;\n}\n.nav-link,\n.nav-link:hover {\n  color: black;\n}\n\n/* .react-flow__node-input, */\n.react-flow__node {\n  height: 28px !important;\n  width: 28px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
